import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import {
  getMarginBottomClass,
  marginBottomLevels,
} from '../../utils/marginBottom';
import Panel from '../Panel';
import { Grid, Row, Cell } from '../Grid';

import styles from './product-basket.css';

export const ProductBasketType = {
  DEFAULT: 'default',
  CHARCOAL: 'charcoal',
};

const ProductBasket = ({
  children,
  imageSlot,
  type,
  marginBottom,
  verticalImage,
}) => (
  <div className={cn(styles.ProductBasket, getMarginBottomClass(marginBottom))}>
    <Panel type={type}>
      <Grid>
        <Row>
          <Cell sizeLarge={10} offsetLarge={1}>
            <div className={styles.flexContainer}>
              {imageSlot && (
                <div
                  className={cn({
                    [styles.image]: !verticalImage,
                    [styles['image-vertical']]: verticalImage,
                  })}
                >
                  {imageSlot}
                </div>
              )}
              <div>{children}</div>
            </div>
          </Cell>
        </Row>
      </Grid>
    </Panel>
  </div>
);

ProductBasket.displayName = 'ProductBasket';

ProductBasket.defaultProps = {
  marginBottom: 5,
  verticalImage: false,
};

ProductBasket.propTypes = {
  marginBottom: PropTypes.oneOf(marginBottomLevels),
  type: PropTypes.oneOf([
    ProductBasketType.DEFAULT,
    ProductBasketType.CHARCOAL,
  ]),
  imageSlot: PropTypes.node,
  children: PropTypes.node,
  verticalImage: PropTypes.bool,
};

export { ProductBasket };

export default ProductBasket;
